import { Container } from 'react-bootstrap'

import NavbarPages from '../NavbarPages'
import HeaderPages from '../HeaderPages'
import KiveUso from '../../../Resourses/products/kive-uso-general-adhesiva-transparente.svg'

const imgHeader = "./images/productos/header-productos-kive-cinta-invisible.jpg";
const imgThumbIzq = "./images/productos/productos_thumbs--cinta--adhesiva--invisible--kive.jpg";
const altText = "CINTA ADHESIVA INVISIBLESE";

const tipoColor = 'productos__detail--tipoTransparente'
const detailLine1 = "CINTAS";
const detailLine2 = "ADHESIVAS";
const detailLine3 = "INVISIBLES";

const imgTable ="./images/productos/kive/cuadro-kive-cinta-invisible.jpg";

// 
// 
// 
// 
// D

const textoDetail1 = 'Cintas adhesivas invisibles, ideales para aplicar sobre papel, fotocopias, escaneados de imágenes y documentos.'
const textoDetail2 = 'Su uso es muy versátil, dado que al tapar con la cinta lo que se quiere corregir (sobre la fotocopia, o escaneado), muestra un espacio como si estuviese vacío y luego se puede remover la cinta, sin romper el papel, a su vez, se puede escribir por encima de ella con bolígrafo, lápiz o marcador.'
const textoDetail3 = 'De gran utilidad en hogares, oficinas y es la preferida de los estudiantes de arquitectura y diseño.'

const imgThumb1 = './images/productos/kive/kive-cinta-de-adhesiva-transparente-1.jpg';
const imgThumb1Alt = 'CINTA ADHESIVA TRANSPARENTE';

const imgThumb2 = './images/productos/kive/kive-cinta-de-adhesiva-transparente-2.jpg';
const imgThumb2Alt = 'Packaging de CINTA ADHESIVA TRANSPARENTE';

const imgThumb3 = './images/productos/kive/kive-cinta-de-adhesiva-transparente-3.jpg';
const imgThumb3Alt = 'CINTA Adhesivas empaquetadas';



const CintaAdhesivaInvisible = () => {
  return (
    <Container className='mb-0'>
        <NavbarPages className="p-0" />
        <div className='row'>
          <div className='col-12 mb-4'>
            <HeaderPages img={imgHeader} alt={"Productos Kive Cintas"} />
          </div>
          <div className='col-12 col-sm-6 col-md-5 productos__imgContainer'>
            <img 
              src={imgThumbIzq} 
              alt={altText} 
              className='d-block w-100 productos__imgContainer--img' 
              loading='lazy'/>
          </div>
          <div className='col-12 col-sm-12 col-md-7 productos__vert--int mb-4 mt-1'>
            <div className='row productos__detail'>
              <div className='col-12'>
                <p className={`productos__detail--tipo ${tipoColor}`}>{detailLine1}</p>
                <p className={`productos__detail--caracteristica ${tipoColor}`}>{detailLine2}</p>
                <p className={`productos__detail--caracteristica ${tipoColor}`}>{detailLine3}</p>
                <img src={KiveUso} className='d-block productos__detail--svg' alt='' loading="lazy" />
              </div>
              <div className='col-12 productos__detail'>
                <img  src={imgTable} 
                      className='d-block w-100' 
                      alt={altText}
                      loading="lazy" />
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-12 productos__vert mb-4 mt-1'>
            <p className='site_text productos__text--int mb-0'> 
              {textoDetail1}<br/>
              {textoDetail2}<br/>
              {textoDetail3}
            </p>
          </div>
        </div>
        <div className='row'>
        
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb1} className='d-block w-100 p-0 m-0 ' alt={ imgThumb1Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb2} className='d-block w-100 p-0 m-0 ' alt={ imgThumb2Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb3} className='d-block w-100 p-0 m-0 ' alt={ imgThumb3Alt} loading="lazy" />
            </div>
        </div>       
      </Container>
    
  )
}

export default CintaAdhesivaInvisible